// extracted by mini-css-extract-plugin
module.exports = {"networking":"Networking_networking__y22s0"};